import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const ChartOfAccounts = lazy(() => import('./ChartOfAccounts'));
const JournalEntries = lazy(() => import('./JournalEntries'));
const RecurringJournalEntries = lazy(() => import('./RecurringJournalEntries'));
const Expenses = lazy(() => import('./Expenses'));
const ExpenseCategories = lazy(() => import('./ExpenseCategories'));
const CreditNotes = lazy(() => import('./CreditNotes'));
const DebitNotes = lazy(() => import('./DebitNotes'));
const BankReconciliation = lazy(() => import('./BankReconciliation'));
const FixedAssets = lazy(() => import('./FixedAssets'));
const BankGuarantees = lazy(() => import('./BankGuarantees'));
const Leases = lazy(() => import('./Leases'));
const Shareholders = lazy(() => import('./Shareholders'));
const PettyCash = lazy(() => import('./PettyCash'));
const Payments = lazy(() => import('./Payments'));

export const accountingRoutes = (
    <React.Fragment key="accounting">
        <Route element={<ProtectedRoute permission="finance.journal_entry.view" />}>
            <Route path="/chart-of-accounts" element={<ChartOfAccounts />} />
            <Route path="/bank-reconciliation" element={<BankReconciliation />} />
            <Route path="/accounting/shareholders" element={<Shareholders />} />
            <Route path="/accounting/fixed-assets" element={<FixedAssets />} />
            <Route path="/accounting/leases" element={<Leases />} />
            <Route path="/journal-entries" element={<JournalEntries />} />
            <Route path="/recurring-journal-entries" element={<RecurringJournalEntries />} />
            <Route path="/bank-guarantees" element={<BankGuarantees />} />
        </Route>
        <Route element={<ProtectedRoute permission="finance.payment.view" />}>
            <Route path="/payments" element={<Payments />} />
        </Route>
        <Route element={<ProtectedRoute permission="finance.expense.view" />}>
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/expense-categories" element={<ExpenseCategories />} />
        </Route>
        <Route element={<ProtectedRoute permission="sales.credit_note.view" />}>
            <Route path="/credit-notes" element={<CreditNotes />} />
        </Route>
        <Route element={<ProtectedRoute permission="procurement.debit_note.view" />}>
            <Route path="/debit-notes" element={<DebitNotes />} />
        </Route>
        <Route element={<ProtectedRoute permission="finance.petty_cash.view" />}>
            <Route path="/accounting/petty-cash" element={<PettyCash />} />
        </Route>
    </React.Fragment>
);
